import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled, Theme } from '@mui/material/styles';

interface DashboardPageFrameProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function DashboardPageFrame({
  title,
  description,
  children,
}: DashboardPageFrameProps) {
  return (
    <FrameRoot>
      <FrameHeader>
        <TitleText>{title}</TitleText>
        {description ? <DescriptionText>{description}</DescriptionText> : null}
      </FrameHeader>
      {children}
    </FrameRoot>
  );
}

export const dashboardPageFrameStyles = (theme: Theme) => ({
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[8],
});

const FrameRoot = styled(Box)(({ theme }) => dashboardPageFrameStyles(theme));

const FrameHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const TitleText = styled(Typography)(({ theme }) => ({
  width: '100%',
  color: theme.palette.grey[800],
  fontSize: theme.typography.pxToRem(32),
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 'normal',
}));

const DescriptionText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  color: theme.palette.text.secondary,
}));
